// Global Utils
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

// Global Types
import { AppState } from 'services/types';

// Global selectors
import { selectDiaryFilterType } from 'services/sprayEvents/selectors';
import { selectFertilizerEventsFilterType } from 'services/fertilizerEvents/selectors';
import { SprayEventFilterType } from 'services/sprayEvents/types';
import { FertilizerEventFilterType } from 'services/fertilizerEvents/types';
import { SPRAY_EVENTS_NAMESPACE } from 'services/sprayEvents/constants';
import { FERTILIZER_EVENTS_NAMESPACE } from 'services/fertilizerEvents/constants';
import { Props } from '.';

const selectNamespace = (_state: AppState, props: Props): string | undefined =>
    props.namespace;

const selectFilterType = createDeepEqualSelector(
    [selectNamespace, selectDiaryFilterType, selectFertilizerEventsFilterType],
    (
        namespace,
        filterTypeForSprayEvents,
        filterTypeForFertilizerEvents
    ): SprayEventFilterType | FertilizerEventFilterType => {
        switch (namespace) {
            case FERTILIZER_EVENTS_NAMESPACE:
                return filterTypeForFertilizerEvents;
            case SPRAY_EVENTS_NAMESPACE:
            default:
                return filterTypeForSprayEvents;
        }
    }
);

export { selectFilterType };
